import { render } from "./PickleForm.vue?vue&type=template&id=6c2349f0&scoped=true&ts=true"
import script from "./PickleForm.vue?vue&type=script&lang=ts"
export * from "./PickleForm.vue?vue&type=script&lang=ts"

import "./PickleForm.vue?vue&type=style&index=0&id=6c2349f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c2349f0"]])

export default __exports__